import React, { FC } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { DraftStatus } from 'api/Responses/SetResponses';
import BreadCrumbs from 'components/BreadCrumb/BreadCrumbs';
import Page from 'components/Page';
import PageSpinner from 'components/PageSpinner/PageSpinner';
import SetTable from 'components/Table/SetTable';
import { TableContainer } from 'components/Table/Table';
import { useSet } from 'hooks/useSet';
import { helpers } from 'pages/Set/machines/ApprovalWorkflow/machine';
import { useUser } from 'store/user/useUser';
import SetActionButtons from '../molecules/SetActionButtons';
import * as Styles from '../SetPage.styles';

type SetPageParams = {
  code: string;
};

const EditSetPage: FC = () => {
  const { code = '' } = useParams<SetPageParams>();

  const navigate = useNavigate();
  const { loading, set, dispatchSet } = useSet(code, false, true);
  const user = useUser();

  // Make sure is draft
  const isDraft = helpers.mapDraftStatusToMachineState(set.status) === DraftStatus.DRAFT;

  // Check if user is owner
  const isOwner = user.isAuthenticated && set.owned_by === user.user_id;

  // Return if draft exists and owned by someone else
  if (isDraft && isOwner && set.code) {
    navigate(`/set/${set.code}`, { replace: true });
  }

  return (
    <Page>
      {loading || !set || !user.isAuthenticated ? (
        <PageSpinner />
      ) : (
        <Styles.SetPageContainer>
          <BreadCrumbs status={set.status} />
          <Styles.SetHeader>
            <a href={`#${set.code}`}>
              <h1>{set.display_code}</h1>
            </a>
            <SetActionButtons currentUser={user} setDraft={set} updateSet={dispatchSet} />
          </Styles.SetHeader>
          <Styles.SetLinksList>
            {Object.keys(set.trays).map(trayID => (
              <Styles.SetLink key={trayID} href={`#${trayID}`}>
                {trayID}
              </Styles.SetLink>
            ))}
          </Styles.SetLinksList>
          <TableContainer>
            <SetTable set={set} dispatchSet={dispatchSet} disabled={false} />
          </TableContainer>
        </Styles.SetPageContainer>
      )}
    </Page>
  );
};

export default EditSetPage;
